// Modules
import styled from 'styled-components';

// Styles
import { Body, BodyBoldTwo } from '../../styles/common/typo.styles';

// Types
import { styledComponentProps } from '../../types/theme';

export const Fields = styled.div`
	flex: 0 0 34%;
	@media ${({ theme }: styledComponentProps): string => theme.breakpoints.lg} {
		flex: 1;
		width: 100%;
	}
	margin-bottom: 30px;
`;

export const Field = styled.div`
	display: flex;
	align-items: center;
	background-color: ${({ theme }: styledComponentProps): string =>
		theme.colors.ui.white};
	padding: 10px;
	margin-bottom: 5px;
	flex-direction: ${({ direction }: styledComponentProps): string => {
		return direction === 'rtl' ? `row-reverse` : `row`;
	}};
`;

export const P = styled(Body)<any>`
	color: ${({ theme }: styledComponentProps): string =>
		theme.colors.ui.barIlanGreen};
	width: calc((100% - 48px) * 0.6);
`;

export const FieldLabel = styled.div`
	display: flex;
	align-items: center;
`;
export const FieldLabelText = styled(Body)<any>`
	color: ${({ theme }: styledComponentProps): string =>
		theme.colors.ui.barIlanGreen};
	width: calc((100% - 48px) * 0.4);
`;

export const FieldIcon = styled.img<any>`
	margin: 0 ${({ lg }) => (lg ? 11 : 16)}px;
	width: ${({ lg }) => (lg ? 26 : 16)}px;
	height: ${({ lg }) => (lg ? 26 : 16)}px;
`;

export const PBold = styled(BodyBoldTwo)`
	color: ${({ theme }: styledComponentProps): string =>
		theme.colors.ui.barIlanGreen};
`;



export const Link = styled.a<any>`
	color: ${({ theme }: styledComponentProps): string =>
		theme.colors.ui.jungleGreen};
	text-decoration: underline;
	cursor: pointer;
`;



export const AdditionalInfo = styled.div`

	@media ${({ theme }: styledComponentProps): string => theme.breakpoints.lg} {
		display: none;
	}
`;